export const modelLocation = '/3d/iphone-compressed.glb'
export enum Transitions {
    FADE = 'fade',
    TIKTOK = 'tiktok',
}
